<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>{{ id ? "编辑活动" : "新增活动" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content" style="padding-top: 15px">
      <el-form ref="goodsForm" :model="goodsForm" :rules="rules" label-width="120px">
        <el-form-item label="活动名称：" prop="activityName">
          <el-input
            v-model="goodsForm.activityName"
            placeholder="请输入活动名称"
            style="width: 320px"
            :maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动时间：" prop="time">
          <el-date-picker
            v-model="goodsForm.time"
            @change="timeChange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="expireTimeOption"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="活动类型：" prop="activitySubType">
          <el-select
            v-model="goodsForm.activitySubType"
            placeholder="请选择活动类型"
            clearable
          >
            <el-option
              v-for="item in activitySubTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频号视频ID" v-if="goodsForm.activitySubType != 201">
          <el-tag
            :key="tagindex"
            v-for="(tag, tagindex) in goodsForm.videoHomeVideoIds"
            closable
            :disable-transitions="false"
            @close="handleClose(tagindex)"
            >{{ tag }}</el-tag
          >
          <el-input
            class="input-new-tag"
            v-if="attrValueInputVisible"
            v-model="attrValueInputValue"
            :ref="`saveTagInput`"
            size="small"
            @keyup.enter.native="handleAttrValueInputConfirm()"
            @blur="handleAttrValueInputConfirm()"
          ></el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showAttrValueInput()"
            >+ 添加</el-button
          >
        </el-form-item>
        <el-form-item label="视频号主页ID" v-if="goodsForm.activitySubType == 201">
          <el-input
            v-model="goodsForm.videoHomeId"
            placeholder="请输入视频号主页ID"
            type="text"
          ></el-input>
        </el-form-item>
        <el-form-item label="优惠券">
          <span
            v-if="!currentCoupon.title"
            class="chooseText"
            @click="showDialogCoupon = true"
            >选择优惠券</span
          >
          <div v-else>
            <span>已选择：</span>
            <span>{{ currentCoupon.title }}</span>
            <span class="chooseText" @click="showDialogCoupon = true"> 重新选择</span>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>

    <dialog-coupon
      :isShow="showDialogCoupon"
      @hideDialogCoupon="hideDialogCoupon"
      @confirmCoupon="confirmCoupon"
    >
    </dialog-coupon>
  </div>
</template>

<script>
import {
  addOrUpdateActivity,
  getSingleActivityList,
  getShopInfo,
  findCashCouponBatchOrderBean,
} from "../api/index";
import dialogCoupon from "@/components/dialogCoupon.vue";
export default {
  data() {
    return {
      id: "",
      goodsForm: {
        activityName: "",
        time: "",
        startTime: "",
        endTime: "",
        indexNo: 1,
        activitySubType: "",
        videoHomeId: "",
        videoHomeVideoIds: [],
      },
      rules: {
        activityName: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        time: [{ required: true, message: "请选择日期", trigger: "change" }],
        activitySubType: [{ required: true, message: "请选择活动类型", trigger: "blur" }],
      },
      dialogGoodsSel: false,
      activitySubTypeList: [
        { label: "主页关注领券", value: 201 },
        { label: "视频点赞领券", value: 202 },
        { label: "转发朋友圈领券", value: 203 },
      ],
      confirmList: {},
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      attrValueInputVisible: false,
      attrValueInputValue: "",
      showDialogCoupon: false,
      currentCoupon: {},
    };
  },
  components: {
    dialogCoupon,
  },
  beforeDestroy() {
    localStorage.removeItem("updateActivityId");
  },
  mounted() {
    this.id = localStorage.updateActivityId;
    console.log(this.id, "id");
    this.getSingleActivityList(this.id);
    getShopInfo().then((shopInfo) => {
      shopInfo.data.videoHomeVideoIds = shopInfo.data.videoHomeVideoIds
        ? shopInfo.data.videoHomeVideoIds.split(",")
        : [];

      this.goodsForm.videoHomeVideoIds = shopInfo.data.videoHomeVideoIds;
      this.goodsForm.videoHomeId = shopInfo.data.videoHomeId;
    });
  },
  methods: {
    // 隐藏优惠券弹窗
    hideDialogCoupon() {
      this.showDialogCoupon = false;
    },

    confirmCoupon(coupon) {
      this.showDialogCoupon = false;
      this.currentCoupon = coupon;
    },
    handleClose(index) {
      this.goodsForm.videoHomeVideoIds.splice(index, 1);
    },
    handleAttrValueInputConfirm() {
      let attrValueInputValue = this.attrValueInputValue;
      if (attrValueInputValue) {
        this.goodsForm.videoHomeVideoIds.push(attrValueInputValue);
      }
      this.attrValueInputVisible = false;
      this.attrValueInputValue = "";
    },
    showAttrValueInput() {
      this.attrValueInputVisible = true;
      this.$nextTick((_) => {
        this.$refs[`saveTagInput`].focus();
      });
    },
    getSingleActivityList(activityId) {
      getSingleActivityList({
        activityId: activityId,
      }).then((res) => {
        if (res.code == 1) {
          Object.assign(this.goodsForm, res.data);
          this.$set(this.goodsForm, "time", [res.data.startTime, res.data.endTime]);
          if (this.goodsForm.cashCouponBatchId) {
            findCashCouponBatchOrderBean({
              cashCouponBatchOrderId: this.goodsForm.cashCouponBatchId,
            }).then((coupon) => {
              console.log(coupon);
              if (coupon.code == 1) {
                this.currentCoupon.id = coupon.data.id;
                this.currentCoupon.title = coupon.data.title;
                console.log(this.currentCoupon);
                this.$forceUpdate();
              }
            });
          }
        }
      });
    },
    timeChange(val) {
      if (val && val.length) {
        console.log(val);
        this.goodsForm.startTime = val[0];
        this.goodsForm.endTime = val[1];
      } else {
        this.goodsForm.startTime = "";
        this.goodsForm.endTime = "";
      }
    },
    priceBlur(e) {
      let value = e.target.value;
      if (value != "") {
        if (value.indexOf(".") > -1) {
          this.goodsForm.score = value.slice(0, value.indexOf(".") + 3);
        } else {
          this.goodsForm.score = value.toFixed(2);
        }
      }
    },
    submit() {
      this.$refs.goodsForm.validate((valid) => {
        if (!valid) {
          this.$notify({
            title: "提示",
            message: "请输入相应信息",
            type: "warning",
            duration: 1000,
          });
          return;
        } else {
          let params = JSON.parse(JSON.stringify(this.goodsForm));
          params.videoHomeVideoIds = params.videoHomeVideoIds.join(",");
          params.activityType = 200;
          params.cashCouponBatchId = this.currentCoupon.id || "";
          if (this.id) {
            params.activityId = this.id;
          }
          addOrUpdateActivity(params).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: `${this.id ? "修改成功" : "新增成功"}`,
                type: "success",
                duration: 1000,
              });
              this.$router.push("/videoAccountActivities");
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "warning",
                duration: 1000,
              });
            }
          });
        }
      });
    },
    deleteGoods() {
      this.confirmList = {};
    },
    confirmSelGoods(confirmList) {
      this.hideSelGoods();
      this.confirmList = confirmList;
    },
    hideSelGoods() {
      this.dialogGoodsSel = false;
    },
  },
};
</script>

<style lang="less" scoped>
.flex-row-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.specification-header {
  width: 452px;
  height: 40px;
  background: #f8f8f8;
  padding: 0 10px;
  color: #606266;
  font-size: 12px;
}
.specification-body {
  width: 450px;
  height: auto;
  border: 1px solid #ececec;
  border-top: none;
  padding: 0 10px;
  line-height: 40px;
}
.width25 {
  width: 25%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
  box-sizing: border-box;
  &:last-child {
    cursor: pointer;
  }
}

.chooseText {
  color: rgb(31, 107, 248);
  cursor: pointer;
}
.el-tag {
  margin-right: 10px;
}
</style>
